import { AppState, AppStateActionParams } from 'records/AppState';
import { Interaction, InteractionList } from 'records/interactions';

export interface InteractionActions {
  setInteractions: (
    actionParams: AppStateActionParams,
    interactions: InteractionList
  ) => AppState;

  createInteraction: (
    actionParams: AppStateActionParams,
    interaction: Interaction
  ) => AppState;

  updateInteraction: (
    actionParams: AppStateActionParams,
    interaction: Interaction
  ) => AppState;

  deleteInteractions: (
    actionParams: AppStateActionParams,
    interactionType: string
  ) => AppState;

  clearInteractions: (actionParams: AppStateActionParams) => AppState;
}

const interactionActions: InteractionActions = {
  setInteractions: (
    { state }: AppStateActionParams,
    interactions: InteractionList
  ): AppState => {
    return state().set('interactions', interactions);
  },

  createInteraction: (
    { state }: AppStateActionParams,
    interaction: Interaction
  ): AppState => {
    return state().update(
      'interactions',
      (interactions): InteractionList => interactions.push(interaction)
    );
  },

  updateInteraction: (
    { state }: AppStateActionParams,
    updatedInteraction: Interaction
  ): AppState => {
    return state().update('interactions', (interactions): InteractionList => {
      const index = interactions.findIndex(
        (i): boolean => i.type === updatedInteraction.type
      );

      return interactions.set(index, updatedInteraction);
    });
  },

  deleteInteractions: (
    { state }: AppStateActionParams,
    interactionType: string
  ): AppState => {
    return state().update('interactions', (interactions) => {
      return interactions.filter((i) => i.type !== interactionType);
    });
  },

  clearInteractions: ({ state }: AppStateActionParams): AppState => {
    return state().update('interactions', (interactions): InteractionList => {
      return interactions.clear();
    });
  },
};

export default interactionActions;
